export const SMARTPHONE = '@/SMARTPHONE';
export const TABLET = '@/TABLET';
export const DESKTOP = '@/DESKTOP';

export const DEVICES = {
  Tablet: TABLET,
  Phone: SMARTPHONE,
};
